export default "__VITE_ASSET__DFW3k3RU__"